import type { ReactNode } from "react";

export type SwitchOption = { id: string; label: string; flag?: string; lang?: string };

/** Pill buttons for a short list of exclusive choices (language, currency); picking one applies it right away. */
export function OptionSwitch({ label, options, value, onSelect, disabled = false, columns }: { label: string; options: readonly SwitchOption[]; value: string; onSelect: (id: string) => void; disabled?: boolean; columns?: number }): ReactNode {
  return (
    <div className="field">
      <span className="field__label">{label}</span>
      <div className={columns ? "option-switch option-switch--grid" : "option-switch"} style={columns ? { gridTemplateColumns: `repeat(${columns}, max-content)` } : undefined} role="radiogroup" aria-label={label}>
        {options.map((option) => (
          <button key={option.id} type="button" role="radio" aria-checked={value === option.id} lang={option.lang} className={value === option.id ? "option-switch__btn option-switch__btn--active" : "option-switch__btn"} disabled={disabled} onClick={() => { if (value !== option.id) onSelect(option.id); }}>
            {option.flag ? <img className="option-switch__flag" src={`/flags/${option.flag}.svg`} alt="" aria-hidden="true" loading="lazy" decoding="async" /> : null}
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
}
